export default __webpack_public_path__ + "static/media/section3Bg.8d71c7b2.png";